import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Payment } from '../models/payment';
import { InvoiceService } from '../services/invoice.service';
import { SplitSheetModalService } from 'src/app/shared/services/split-sheet-modal.service';
import { EMPTY, Observable, Subscription, catchError, debounceTime, distinctUntilChanged, exhaustMap, filter, forkJoin, iif, map, of, switchMap } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { ProfessionalService } from 'src/app/shared/services/professional.service';
import { PostalCodeService } from 'src/app/shared/services/postal-code.service';
import { BankService } from 'src/app/shared/services/bank.service';
import { TypeExpensesService } from 'src/app/shared/services/type-expenses.service';
import { RevenueInvoiceSettingsService } from 'src/app/shared/services/revenue-invoice-settings.service';
import { ExameService } from 'src/app/shared/services/exame.service';
import { SpecialtiesService } from 'src/app/shared/services/specialties.service';
import { ServicesService } from 'src/app/shared/services/services.service';
import { RevenueInvoiceEventService } from 'src/app/shared/services/revenue-invoice-event.service';
import { RevenueService } from 'src/app/shared/services/revenue.service';
import { PaymentMachineService } from 'src/app/shared/services/payment-machine.service';
import { RevenuePaymentMethodService } from 'src/app/shared/services/revenue-payment-method.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { MachineOrderService } from 'src/app/shared/services/machine-order.service';
import { ServeSendEventService } from 'src/app/shared/services/serve-send-event.service';
import { ClientService } from 'src/app/shared/services/client.service';
import { UnidadeService } from 'src/app/shared/services/unidade.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectMainUnit } from 'src/app/store/unidade/unidade.selectors';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { ConfirmationService } from 'primeng/api';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { co } from '@fullcalendar/core/internal-common';



export function paymentValidator(control: AbstractControl): ValidationErrors | null {
  const revenue = control.get('revenue');
  const payments = revenue?.get('payments')?.value as Array<{ value: number }> | null | undefined;
  const expected = Number(revenue?.get('value')?.value ?? 0);

  const total = (payments ?? []).reduce((sum, p) => sum + Number(p?.value ?? 0), 0);
  return total > expected ? { invalidPayment: true } : null;
}



@Component({
  selector: 'app-receita-form',
  templateUrl: './receita-form.component.html',
  styleUrls: ['./receita-form.component.scss'],
  providers: [ConfirmationService]
})
export class ReceitaFormComponent implements OnInit, OnDestroy {

  iuiuid!: string;

  listNF: Array<any> = [
    { name: 'Sim', code: 1 },
    { name: 'Sim, com reembolso', code: 2 },
    { name: 'NÃ£o', code: 3 }
  ];

  listPaymentsMethod: Array<any> = [
    { name: 'Crédito', code: 1, '@id': '/api/payment_methods/1' },
    { name: 'Dinheiro', code: 2, '@id': '/api/payment_methods/2' },
    { name: 'Débito', code: 3, '@id': '/api/payment_methods/3' },
    { name: 'Pix', code: 4, '@id': '/api/payment_methods/4' },
    { name: 'Ted/Doc', code: 5, '@id': '/api/payment_methods/5' }
  ];

  listMachine: Array<any> = [];

  listBank = [
    { name: 'BTG', code: 1 }
  ];

  listService: any = [];

  listInstallment: any = {};
  listIntallmentCreditCount: Array<any> = [];

  listExams: any[] = [];

  listRevenueInvoiceSettings: any[] = [];

  listProfessionals: any[] = [];

  listSpecialties: any[] = [];

  listTypeRevenue: any[] = [];

  listStates = this.postalCodeService.states;

  listCities: any[] = [];

  paymentTypeMachine = [
    {
      id: "/api/payment_methods/1",
      type: "credit"
    },
    {
      id: "/api/payment_methods/3",
      type: "debit"
    }
  ]

  public validators = Validators;

  public isSplitted: boolean = false;


  public formReceita: FormGroup = this.formBuilder.group({
    id: [null],
    invoice: ['', Validators.required],
    revenue: this.formBuilder.group({
      id: [{ value: '', disabled: true }],
      externalId: [null],
      client: [null],
      unit: [null],
      date: [new Date(), Validators.required],
      value: [null, [Validators.required]],
      itemCategory: ['service'],
      professional: [null],
      specialty: [{ value: null, disabled: true }],
      exam: [null],
      service: [{ value: null, disabled: true }],
      category: ["/api/revenues/1", Validators.required],
      customer: [null],
      invoiceBlocked: [false],
      comissionProfessional: [null as any],
      payer: this.formBuilder.group({
        id: [null],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        taxId: ['', [Validators.required, CustomValidator.validateTaxId()]],
        contactNumber: [null, CustomValidator.validateContactNumber()],
      }),
      payments: this.formBuilder.array([]),
      description: ['', Validators.pattern('^[\\w\\d\\s.<>;:,#\"!¡$&()¿?=*\\/\\\\+\\-_^\\[\\]{}~@¬|°áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]+$')],
    }),
    address: this.formBuilder.group({
      postalCode: ['', [Validators.required, Validators.minLength(8)]],
      streetAddress: ['', Validators.required],
      number: ['', Validators.required],
      district: ['', Validators.required],
      address2: [''],
      ibge: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      country: ['Brasil', Validators.required],
      email: ['', [Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]*$')]],
    })
  }, { validators: paymentValidator });
  isWaitingPayment: boolean = false;
  qrCodeUrl: any = "";

  isEdit: boolean = true;

  get revenue() {
    return this.formReceita.get('revenue') as FormGroup
  }

  get issueEmitInvoice() {
    return (this.formReceita.get('invoice')?.value == "/api/revenue_invoice_settings/1" ||
      this.formReceita.get('invoice')?.value == "/api/revenue_invoice_settings/2")
      && this.revenue.get('invoiceBlocked')?.value == false && this.issueInvoice == false;;
  }

  get isInvoiceRequested() {
    const invoice = this.formReceita.get('invoice')?.value;
    return invoice == "/api/revenue_invoice_settings/1" ||
      invoice == "/api/revenue_invoice_settings/2" ||
      (invoice == "/api/revenue_invoice_settings/3" && this.issueInvoice == true);
  }

  get issueAddress() {
    return this.isInvoiceRequested && !this.isInvoiceBlockedByUser;
  }

  get isInvoice3WithIssueInvoiceRequired() {
    return this.formReceita.get('invoice')?.value == "/api/revenue_invoice_settings/3" &&
      this.issueInvoice == true &&
      !this.isInvoiceBlockedByUser;
  }

  get isInvoiceBlockedByUser() {
    return this.revenue.get('invoiceBlocked')?.value === true;
  }

  get isAddressOptional() {
    const blockedByUser = this.isInvoiceBlockedByUser;
    const setting3WithoutInvoice = this.formReceita.get('invoice')?.value == "/api/revenue_invoice_settings/3" && this.issueInvoice == false;
    return blockedByUser || setting3WithoutInvoice;
  }

  get requiresAddress() {
    return this.isInvoiceRequested && !this.isAddressOptional;
  }

  get hasPostalCodeStarted() {
    return String(this.address.get('postalCode')?.value ?? '').trim().length > 0;
  }

  get hasCompletePostalCode() {
    return this.onlyNumbers(this.address.get('postalCode')?.value).length == 8;
  }

  get requiresAddressCompletion() {
    return this.requiresAddress || this.hasPostalCodeStarted;
  }

  get addressLabelSuffix() {
    return this.requiresAddressCompletion ? '' : ' (opcional)';
  }

  get shouldShowInvoiceBlockedBanner() {
    return this.isInvoiceBlockedByUser && this.issueAddress;
  }

  get addressRequiredMessageVisible() {
    return this.requiresAddress && this.address.invalid;
  }

  get addressCompletionMessageVisible() {
    return !this.requiresAddress && this.hasPostalCodeStarted && this.address.invalid;
  }

  get addressScenarioMessage() {
    return this.requiresAddress
      ? 'Endereço obrigatório - Haverá emissão de nota fiscal para esta venda'
      : 'Endereço opcional - Não haverá emissão de nota fiscal para esta venda via sistema';
  }

  get postalCodeHelperText() {
    if (this.postalCodeLookupStatus == 'complete') {
      return 'Dados preenchidos automaticamente pelo CEP.';
    }

    if (this.postalCodeLookupStatus == 'partial') {
      return 'CEP localizado parcialmente. Complete os dados restantes.';
    }

    return '';
  }

  get isPostalCodeNotFound() {
    return this.postalCodeLookupStatus == 'notFound';
  }

  get shouldBlockAddressFieldsByPostalCode() {
    return this.isEdit == false || !this.hasCompletePostalCode || this.isPostalCodeNotFound;
  }

  get shouldLockFullPostalCodeFields() {
    return this.shouldBlockAddressFieldsByPostalCode || this.postalCodeLookupStatus == 'complete';
  }

  get shouldLockCityStateFields() {
    return this.shouldBlockAddressFieldsByPostalCode ||
      this.postalCodeLookupStatus == 'complete' ||
      this.postalCodeLookupStatus == 'partial';
  }


  get address() {
    return this.formReceita.get('address') as FormGroup
  }

  get payer() {
    return this.revenue.get('payer') as FormGroup;
  }

  get payments() {
    return this.revenue.get('payments') as FormArray;
  }

  get invoice() {
    return this.formReceita.get('invoice') as FormControl;
  }

  get invoiceId() {
    let invoice: any = this.listRevenueInvoiceSettings.find((invoice: any) => invoice['@id'] == (this.formReceita.get('invoice') as FormControl).value)
    return invoice ? invoice.id : undefined;
  }

  get professional(): any {
    return this.listProfessionals.find(professional => professional['@id'] == this.revenue.get("professional")?.value);
  }


  get category(): any {
    return this.listTypeRevenue.find(typeRevenue => typeRevenue['@id'] == this.revenue.get("category")?.value);
  }

  get specialty(): any {
    return this.listSpecialties.find(specialty => specialty['@id'] == this.revenue.get("specialty")?.value);
  }

  get countInvoice() {
    return this.payments.value
      .filter((payment: Payment) => payment.orderId != null)
      .reduce((r: number, n: number) => r + 1, 0)
  }

  get validationData() {
    return this.revenue.get('date')?.valid &&
      this.payer.get('firstName')?.valid &&
      this.payer.get('lastName')?.valid &&
      this.payer.get('taxId')?.valid &&
      this.invoice.valid
  }

  get validationItem() {
    if (this.revenue.get('itemCategory')?.value == "service") {
      return this.revenue.get('professional')?.valid &&
        this.revenue.get('service')?.valid &&
        this.revenue.get('category')?.valid
    }
    return this.revenue.get('category')?.valid &&
      this.revenue.get('exam')?.valid
  }

  get invoiceLoose() {
    return this.invoice.value == "/api/revenue_invoice_settings/4" || this.issueSettingsCachier;
  }


  get clearPayment(): Payment {
    return {
      id: null,
      paymentId: null,
      orderId: null,
      value: null,
      status: null,
      installmentCount: null,
      paymentMethod: null,
      bank: '',
      description: null
    }
  }


  isShowModal: boolean = false;
  isShowModalClients: boolean = false;

  positionPayment!: number;
  selectedPayment!: Payment;
  protected paymentFees!: any;
  protected loadingSheetModalConfirmInvoices: boolean = false;

  protected phoneWhatsApp: FormControl = new FormControl('', [Validators.required]);


  private subscription: any[] = [];


  loading: boolean = false;
  loadingInvoice: boolean = false;
  isReqFinished: boolean = true

  selectedMachine?: string;
  selectMachine: any;

  loadingCancel: boolean = false;

  public issueInvoice: boolean = false;
  public issueDiffDay: boolean = false;
  public issueSettingsCachier: boolean = false;
  public issueEdit: boolean = false;
  public postalCodeLookupStatus: 'idle' | 'complete' | 'partial' | 'notFound' = 'idle';

  protected isNextStepEnabled: boolean = true;

  protected client?: any;

  protected dialogInvoiceBlocked: boolean = false;
  public isEditingCommission: boolean = false;

  protected taxIdChangesObservable = this.payer.get("taxId")?.valueChanges.pipe(
    debounceTime(1000),
    distinctUntilChanged(),
    switchMap(
      (value: any) => {
        if (this.payer.get("taxId")?.valid && this.payer.get("taxId")?.dirty) {
          return this.revenueInvoiceEventService.getPerson(value).pipe(
            catchError(error => {
              return EMPTY;
            }))
        }
        return EMPTY;
      }
    )
  ) as Observable<any>;



  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private formBuilder: FormBuilder,
    private splitSheetModalService: SplitSheetModalService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private professionalService: ProfessionalService,
    private postalCodeService: PostalCodeService,
    private revenueService: RevenueService,
    private revenueInvoiceSettingsService: RevenueInvoiceSettingsService,
    private examService: ExameService,
    private specialtiesService: SpecialtiesService,
    private servicesService: ServicesService,
    private revenueInvoiceEventService: RevenueInvoiceEventService,
    private paymentMachineService: PaymentMachineService,
    private revenuePaymentMethodService: RevenuePaymentMethodService,
    private notifyService: NotifyService,
    private machineOrderService: MachineOrderService,
    private serveSendEventService: ServeSendEventService,
    private clientService: ClientService,
    private bankService: BankService,
    private unitService: UnidadeService,
    private router: Router,
    private permissionService: PermissionService
  ) { }

  get hasCommissionPermission(): boolean {
    return this.permissionService.hasPermission('Comissão');
  }



  ngOnInit(): void {

    this.generateNewIuiuid();
    this.formReceita.get('revenue')?.get('externalId')?.setValue(this.iuiuid);

    this.revenueInvoiceEventService.getCreditTax().subscribe(
      (listTax: any) => {
        this.listInstallment = listTax['credit_card_fees']['default'];
        this.listIntallmentCreditCount = Object.keys(listTax['credit_card_fees']['default']['credit'])
          .map(key => ({ label: Number.parseInt(key), value: Number.parseInt(key) }));
      }
    );


    this.address.get("ibge")?.valueChanges.subscribe(
      (ibge: any) => {
        let city = this.listCities.find((city: any) => city.id == ibge);

        if (city) {
          this.address.get("city")?.setValue(city.nome);
        }
      }
    );

    this.revenue.get("invoiceBlocked")?.valueChanges.subscribe(
      (value: any) => {
        if (this.issueEdit == false) {
          this.dialogInvoiceBlocked = value;
        }
        this.updateAddressValidators();
      }
    )


    let valueChangesSubscribe = this.revenue.get("value")?.valueChanges.pipe(
      debounceTime(1000),
    ).subscribe(
      (value) => {
        this.validateCommission();
        this.updateCommission();
        if (value > 0 && this.payments.value.length <= 0) {
          let payment = Object.assign(this.clearPayment);
          payment.value = value;
          this.addPayment(payment);
        } else {
          this.verifyPayment(0, true);
        }
      }
    );

    let commissionChangesSubscribe = this.revenue.get("comissionProfessional")?.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.validateCommission();
    });

    this.invoice.valueChanges.subscribe(
      (value) => {
        this.getSpecialtyByProfessional();
        this.verifyItemCategory(true);
        this.updateAddressValidators();
      }
    )


    let itemCategorySubscribe = this.revenue.get("itemCategory")?.valueChanges.subscribe(
      (value) => {
        this.verifyItemCategory(true);
      }
    );

    let serviceChangesSubscribe = this.revenue.get("service")?.valueChanges.subscribe(() => {
      this.updateCommission();
    });

    let postalCodeSubscribe = this.address.get("postalCode")?.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap(
        (value: any) => {
          const postalCode = this.onlyNumbers(value);
          if (this.postalCodeLookupStatus == 'notFound') {
            this.postalCodeLookupStatus = 'idle';
          }
          this.clearPostalCodeNotFoundError();
          this.updateAddressValidators();

          if (!postalCode) {
            this.postalCodeLookupStatus = 'idle';
            this.clearAddressAutocompleteFields();
            return EMPTY;
          }

          if (postalCode.length < 8) {
            this.postalCodeLookupStatus = 'idle';
            return EMPTY;
          }

          return this.postalCodeService.getPostalCode(postalCode).pipe(
            catchError(error => {
              this.postalCodeLookupStatus = 'notFound';
              this.clearAddressAutocompleteFields();
              this.updateAddressValidators();
              this.address.get("postalCode")?.setErrors({ ...(this.address.get("postalCode")?.errors ?? {}), cepNotFound: true });
              return EMPTY;
            })
          );
        }
      )
    ).subscribe(
      (value) => {
        if (this.issueEdit == false) {
          const isComplete = !!value.streetAddress && !!value.district && !!value.city && !!value.state;
          this.postalCodeLookupStatus = isComplete ? 'complete' : 'partial';

          this.address.get("streetAddress")?.setValue(isComplete ? value.streetAddress : "");
          this.address.get("district")?.setValue(isComplete ? value.district : "");
          this.address.get("state")?.setValue(value.state);
          this.address.get("ibge")?.setValue(value.ibge);
          this.address.get("city")?.setValue(value.city);
        }
        this.clearPostalCodeNotFoundError();
        this.updateAddressValidators();
        this.getCitiesByState();
      }
    );

    let listForkJoin: any = {
      listProfessionals: this.professionalService.getAll('?units[]=' + localStorage.getItem('unitId')),
      listTypeRevenue: this.revenueService.getAll(),
      listRevenueInvoiceSettings: this.revenueInvoiceSettingsService.getAll(),
      listExams: this.examService.get(`?itemsPerPage=1000&unit=${localStorage.getItem('unitId')}`),
      listPaymentsMethod: this.revenuePaymentMethodService.getAll(),
      listBank: this.bankService.getAll(),
      client: this.clientService.get(Number.parseInt(<string>localStorage.getItem('clientId'))),
      unit: this.unitService.getById(Number.parseInt(<string>localStorage.getItem('unitId')))
    }

    this.loading = true;
    let taxIdChangesSubscribe: any;
    taxIdChangesSubscribe = this.taxIdChangesObservable.subscribe(
      (value) => {
        this.payer.setValue(value, { emitEvent: false });
      }
    );
    let data = this.dynamicDialogConfig.data;
    if (data) {
      switch (data.type) {
        case "invoice":
          this.addInvoice({
            id: data.id,
            paymentId: this.payments.length + 1,
            orderId: data.orderId,
            value: data.value,
            installmentCount: data.installmentCount,
            paymentMethod: data.paymentMethod,
            status: data.status,
            bank: "",
            description: ""
          });
          break;
        case "revenue":
          listForkJoin['revenueInvoiceEventService'] = this.revenueInvoiceEventService.get(data.revenueId);
          break;
      }
    }

    forkJoin(listForkJoin).subscribe(
      (list: any) => {
        this.listProfessionals = list.listProfessionals.filter((professional: any) => professional.isActive == true);
        this.listTypeRevenue = list.listTypeRevenue.filter((professional: any) => professional.status == true);
        this.listRevenueInvoiceSettings = list.listRevenueInvoiceSettings;
        if (list.client?.paymentSetting?.splitModel?.id === 3) {
          this.listRevenueInvoiceSettings = this.listRevenueInvoiceSettings.filter(
            (setting: any) => setting.id !== 2
          );
        }
        this.listExams = list.listExams['hydra:member'].filter((exam: any) => exam.active == true);
        this.listPaymentsMethod = list.listPaymentsMethod;
        this.client = list.client;
        this.listBank = list.client.paymentSetting.customBankFees.map((customBankFees: any) => ({
          id: customBankFees.receivingAccount.bank["@id"],
          name: customBankFees.receivingAccount.bank.name
        }));

        this.issueInvoice = list.unit.flagIssueInvoice;
        console.log(this.issueInvoice)
        this.updateAddressValidators();

        if (list.revenueInvoiceEventService) {

          if (list.revenueInvoiceEventService.revenue.professional && list.revenueInvoiceEventService.revenue.professional.isActive == false) {
            this.listProfessionals.push(list.revenueInvoiceEventService.revenue.professional);
          }
          this.patchRevenue(list.revenueInvoiceEventService);
          this.getSpecialtyByProfessional();
          this.verifyItemCategory();
        }
        this.loading = false;
      }
    );


    this.invoice.valueChanges.subscribe((value) => {
      this.revenue.get('service')?.reset();
      this.revenue.get('professional')?.reset();
      this.revenue.get('specialty')?.reset();
      this.revenue.get('exam')?.reset();
    });

    this.verifyItemCategory();


    this.subscription.push(valueChangesSubscribe);
    this.subscription.push(commissionChangesSubscribe);
    this.subscription.push(itemCategorySubscribe);
    this.subscription.push(serviceChangesSubscribe);
    this.subscription.push(postalCodeSubscribe);
    this.subscription.push(taxIdChangesSubscribe);
  }

  getCitiesByState() {
    if (!this.address.get('state')?.value) {
      this.listCities = [];
      return;
    }

    this.postalCodeService.getCitiesByState(this.address.get('state')?.value)
      .subscribe((cities) => {
        this.listCities = cities.map((city: any) => ({ ...city, id: String(city.id) }));
      });
  }

  updateAddressValidators() {
    const baseRequiredAddressFields = [
      'postalCode',
      'streetAddress',
      'number',
      'district',
      'state',
      'city',
      'country'
    ];
    const shouldRequireAddressFields = this.requiresAddressCompletion;

    Object.keys(this.address.controls).forEach((field) => {
      const control = this.address.get(field);

      if (field == 'email') {
        control?.setValidators([Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]*$')]);
      } else if (field == 'postalCode') {
        control?.setValidators(shouldRequireAddressFields ? [Validators.required, Validators.minLength(8)] : Validators.minLength(8));
      } else if (shouldRequireAddressFields && baseRequiredAddressFields.includes(field)) {
        control?.setValidators(Validators.required);
      } else {
        control?.clearValidators();
      }

      control?.updateValueAndValidity({ emitEvent: false });
    });

    if (this.isPostalCodeNotFound) {
      this.address.get("postalCode")?.setErrors({ ...(this.address.get("postalCode")?.errors ?? {}), cepNotFound: true });
    }
  }

  onlyNumbers(value: any) {
    return String(value ?? '').replace(/\D/g, '');
  }

  clearAddressAutocompleteFields() {
    this.address.get("streetAddress")?.setValue("");
    this.address.get("district")?.setValue("");
    this.address.get("state")?.setValue("");
    this.address.get("ibge")?.setValue("");
    this.address.get("city")?.setValue("");
    this.address.get("number")?.setValue("");
  }

  clearPostalCodeNotFoundError() {
    const postalCodeControl = this.address.get("postalCode");
    const errors = postalCodeControl?.errors;

    if (!errors?.['cepNotFound']) {
      return;
    }

    delete errors['cepNotFound'];
    postalCodeControl?.setErrors(Object.keys(errors).length ? errors : null);
  }



  verifyItemCategory(issueValue: boolean = false) {
    let value = this.revenue.get("itemCategory")?.value;
    let invoice = this.invoice.value;
    if (invoice != "/api/revenue_invoice_settings/4" && invoice != "/api/revenue_invoice_settings/5") {

      if (value == "exam") {
        this.revenue.get('service')?.reset();
        this.revenue.get('professional')?.reset();
        this.revenue.get('specialty')?.reset();

        this.revenue.get('specialty')?.enable();
        this.revenue.get('service')?.enable();

        if (issueValue) {
          this.revenue.get("category")?.setValue("/api/revenues/10");
        }

        this.revenue.get('exam')?.setValidators(Validators.required);
        this.revenue.get('professional')?.clearValidators();
        this.revenue.get('specialty')?.clearValidators();
        this.revenue.get('service')?.clearValidators();
      } else {
        this.revenue.get('exam')?.reset();
        this.revenue.get('exam')?.clearValidators();

        this.revenue.get('specialty')?.disable();
        this.revenue.get('service')?.disable();
        if (issueValue) {
          this.revenue.get("category")?.setValue("/api/revenues/1");
        }

        this.revenue.get('professional')?.setValidators(Validators.required);
        this.revenue.get('service')?.setValidators(Validators.required);
      }
      this.payer.get('taxId')?.setValidators([Validators.required, CustomValidator.validateTaxId()]);
      this.payer.get('firstName')?.setValidators(Validators.required);
      this.payer.get('lastName')?.setValidators(Validators.required);
    } else {
      this.revenue.get('specialty')?.enable();
      this.revenue.get('service')?.enable();
      this.payer.get('taxId')?.clearValidators();
      this.payer.get('firstName')?.clearValidators();
      this.payer.get('lastName')?.clearValidators();
      this.revenue.get("professional")?.clearValidators();
      this.revenue.get("specialty")?.clearValidators();
      this.revenue.get("service")?.clearValidators();
      this.revenue.get("exam")?.clearValidators();
      this.revenue.get("itemCategory")?.clearValidators();

    }

    this.payer.get('taxId')?.updateValueAndValidity();
    this.payer.get('firstName')?.updateValueAndValidity();
    this.payer.get('lastName')?.updateValueAndValidity();


    this.revenue.get('professional')?.updateValueAndValidity();
    this.revenue.get('specialty')?.updateValueAndValidity();
    this.revenue.get('service')?.updateValueAndValidity();
    this.revenue.get('exam')?.updateValueAndValidity();
  }


  patchRevenue(data: any) {
    this.issueEdit = true;
    this.formReceita.get('id')?.setValue(data.id);
    this.formReceita.get('revenue')?.get('externalId')?.setValue(data.revenue.externalId);
    this.formReceita.get('invoice')?.setValue(data.invoice['@id']);

    this.revenue.patchValue(data.revenue, { emitEvent: false });
    this.revenue.get('id')?.setValue(data.id);
    let date = new Date(data.revenue.date);
    date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    this.revenue.get("date")?.setValue(date);
    let now = new Date();
    let diff = now.getTime() - date.getTime();
    let diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    if (diffDays > 1) {
      this.issueDiffDay = true;
    }

    let invoice = data.revenue.professionalInvoice || data.revenue.unitInvoice;
    if (invoice) {
      this.isEdit = invoice.status == "canceled" || invoice.status == "failed" ? true : false;
      console.log(this.isEdit);
    }

    if (data.revenue.service) {
      this.revenue.get("itemCategory")?.setValue("service");
      this.revenue.get("service")?.setValue(data.revenue.service['@id']);
      this.revenue.get("professional")?.setValue(data.revenue.professional['@id']);
      if (data.revenue.specialty) {
        this.revenue.get("specialty")?.setValue(data.revenue.specialty['@id']);
      }
    } else if (data.revenue.exam) {
      this.revenue.get("itemCategory")?.setValue("exam");
      this.revenue.get("exam")?.setValue(data.revenue.exam['@id']);
    }


    this.revenue.get("category")?.setValue(data.revenue.category);

    if (data.revenue.address) {
      this.address.patchValue(data.revenue.address);
    }

    this.revenue.get("value")?.setValue(data.revenue.value);

    if (data.revenue.estimatedProfessionalAmount !== null && data.revenue.estimatedProfessionalAmount !== undefined) {
      this.isEditingCommission = true;
      this.revenue.get("comissionProfessional")?.setValue(data.revenue.estimatedProfessionalAmount);
    } else {
      this.isEditingCommission = false;
    }

    console.log(this.revenue.value);
    data.revenue.payments.forEach((payment: any, index: number) => {
      if (payment.status != "canceled") {
        let index = this.addPayment({
          ...payment,
          paymentMethod: payment.paymentMethod['@id']
        });
        this.verifyPaymentMethod(index);
      }

      if (payment.status == "pending") {
        this.serveSendEventService.createEventSourceOrderMachine(payment.orderId).subscribe(
          (status: any) => {
            this.isWaitingPayment = false;
            this.notifyService.closeAll();
            if (status == "paid" || status == "splitted") {
              this.notifyService.emitSuccess("Pagamento realizado com sucesso");
              this.splitSheetModalService.close("sheetModalPixPayment");
            } else if (status == "canceled") {
              this.payments.get(this.positionPayment.toString())?.get("orderId")?.setValue(null);
              this.notifyService.emitWarn("OperaÃ§Ã£o cancelada");
              this.splitSheetModalService.close("sheetModalPixPayment");
            }
            //status = status == "pending" ? "waiting" : status;
            this.payments.get(this.positionPayment.toString())?.get("status")?.setValue(status);
            this.payments.markAsDirty();
            this.payments.updateValueAndValidity();
          });
      }
    });

  }

  ngOnDestroy(): void {
    this.subscription.map((sub) => sub.unsubscribe());
  }

  addInvoice(paymentModel: Payment) {
    let payment = this.formBuilder.group({
      id: [paymentModel.id],
      paymentId: [this.payments.length - 1],
      orderId: [paymentModel.orderId],
      value: [paymentModel.value, Validators.required],
      paymentMethod: [paymentModel.paymentMethod, Validators.required],
      installmentCount: [paymentModel.installmentCount, Validators.required],
      bank: [null],
      qrCodeUrlPix: [paymentModel.qrCodeUrlPix],
      qrCodePix: [paymentModel.qrCodePix],
      expiresPix: [paymentModel.expiresPix],
      status: [paymentModel.status]
    });

    this.payments.push(payment);

    this.payments.controls.forEach((control: any, index: number) => {
      this.verifyPaymentMethod(index);
    });

  }


  addPayment(paymentModel: Payment) {
    let payment = this.formBuilder.group({
      id: [paymentModel.id],
      paymentId: [this.payments.length - 1],
      orderId: [paymentModel.orderId],
      value: [paymentModel.value, Validators.required],
      paymentMethod: [paymentModel.paymentMethod, Validators.required],
      installmentCount: [{ value: paymentModel.installmentCount, disabled: true }, Validators.required],
      bank: [{ value: paymentModel.bank, disabled: true }],
      qrCodeUrlPix: [paymentModel.qrCodeUrlPix],
      qrCodePix: [paymentModel.qrCodePix],
      expiresPix: [paymentModel.expiresPix],
      status: [paymentModel.status ?? "paid"]
    });

    if (this.issueSettingsCachier) {
      payment?.get("paymentMethod")?.setValue('/api/payment_methods/2');
      payment?.get("installmentCount")?.clearValidators();
    }

    this.payments.push(payment);

    this.payments.controls.forEach((control: any, index: number) => {
      this.verifyPaymentMethod(index);
    });

    return this.payments.length - 1;
  }

  verifyPayment(position: number | null = null, changeTotal: boolean = false) { //| null = null
    if (position != null) {
      let payments = this.payments.value;
      let array = payments.slice(0, position + 1);
      let sum = 0;
      let parents = payments.slice(position + 1);
      let total = this.revenue.get("value")?.value;
      let index: number = position

      parents.forEach((parent: any) => {
        index++;
        if (parent.orderId == null) {
          sum = array.reduce((x: number, y: any) => x + y.value, 0);
          if ((sum + parent.value) > total) {
            let surplus = (sum + parent.value) - total;
            parent = { ...parent, value: parent.value - surplus };
          } else if ((sum + parent.value) < total) {
            let surplus = total - (sum + parent.value);
            if (parent.value < (sum + surplus)) {
              parent = { ...parent, value: parent.value };
            } else
              parent = { ...parent, value: surplus };
          }
        }


        if (parent.value > 0) {
          this.payments.get(index.toString())?.patchValue(parent);
          array.push(parent);
        } else {
          if ((sum + parent.value) == total) {
            this.payments.removeAt(index);
            index--;
          }
        }
      });

      payments = this.payments.value;


      sum = payments.reduce((x: number, y: any) => x + y.value, 0);
      if (payments[payments.length - 1].orderId == null && changeTotal) {
        let value = Math.round((payments[payments.length - 1].value + (total - sum)) * 100) / 100;
        this.payments.get((payments.length - 1).toString())?.get("value")?.setValue(value);
      } else {
        if (sum < total && payments[payments.length - 1].value > 0) {
          this.addPayment(this.clearPayment);
        }
      }
    }
  }

  verifyMachine(event: DropdownChangeEvent) {
    this.selectedMachine = event.value;
    this.selectMachine = {};
    this.splitSheetModalService.push("sheetModalConfirmInvoices");
    this.loadingSheetModalConfirmInvoices = true;
    this.paymentMachineService.getCalculateFees(
      this.selectedPayment.paymentMethod,
      this.selectedPayment.value as number,
      this.selectedPayment.installmentCount as number)
      .subscribe(
        (response) => {
          this.loadingSheetModalConfirmInvoices = false;
          this.paymentFees = response;
        }
      );
  }

  removePayment(position: number) {
    this.payments.removeAt(position);
    this.verifyPayment();
  }

  getSpecialtyByProfessional(isChange: boolean = false) {
    let professionalId = this.revenue.get("professional")?.value;
    if (isChange) {
      this.revenue.get('specialty')?.reset();
      this.revenue.get('service')?.reset();
    }
    let professional: any = this.listProfessionals.find((professional: any) => professional['@id'] == professionalId);
    if (professional) {
      this.specialtiesService.getByProfessional(professional.id).subscribe(
        (specialties: any) => {
          this.listSpecialties = specialties;
          if (specialties.length > 0) {
            this.revenue.get('specialty')?.enable();
          } else {
            this.revenue.get('specialty')?.disable();
          }
          this.getServiceBySpecialty();
        }
      );
    }

  }

  getServiceBySpecialty() {
    let specialtyId = this.revenue.get("specialty")?.value;
    let professionalId = this.revenue.get("professional")?.value;
    let specialty: any = this.listSpecialties.find((specialty: any) => specialty['@id'] == specialtyId);
    let professional: any = this.listProfessionals.find((professional: any) => professional['@id'] == professionalId);
    let params: any = {};

    if (professional) {
      params["professional"] = professional.id;
    }

    if (specialty) {
      params["specialty"] = specialty.id;
    }

    params["itemsPerPage"] = 1000;

    this.servicesService.getAll(params).subscribe(
      (services: any) => {
        this.listService = services;
        this.revenue.get('service')?.enable();
        this.updateCommission();
      }
    );
  }

  verifyService() {
    let category = this.revenue.get("itemCategory")?.value;
    let serviceId = this.revenue.get(category)?.value;


    let service: any = this.listExams.find((service: any) => service['@id'] == serviceId);

    if (category == "service") {
      service = this.listService.find((service: any) => service['@id'] == serviceId);
    }

    if (service) {
      this.revenue.get('value')?.setValue(service.value);
    }

  }


  verifyPaymentMethod(position: any) {
    position = position.toString();
    let paymentMethodId = this.payments.get(position)?.get("paymentMethod")?.value;
    let peymentMethod = this.listPaymentsMethod.find((paymentMethod: any) => paymentMethod['@id'] == paymentMethodId);

    this.payments.get(position)?.get("installmentCount")?.disable();
    this.payments.get(position)?.get("installmentCount")?.clearValidators();

    if (peymentMethod.id === 2) {
      this.payments.get(position)?.get("installmentCount")?.reset();
      this.payments.get(position)?.get("status")?.setValue('paid');
    }


    if (peymentMethod.id === 1) {
      let installmentCount = this.payments.get(position)?.get("installmentCount")?.value ?? 1;

      this.payments.get(position)?.get("installmentCount")?.enable();
      this.payments.get(position)?.get("installmentCount")?.setValue(installmentCount);
      this.payments.get(position)?.get("installmentCount")?.setValidators([Validators.required]);
    }

    if (this.payments.get(position)?.get("status")?.value == 'splitted') {
      this.isSplitted = true;
    }

    this.payments.get(position)?.get("paymentMethod")?.updateValueAndValidity();
    this.payments.get(position)?.get("installmentCount")?.updateValueAndValidity();
  }

  setRevenue() {
    if(this.loading) return;

    console.log(this.revenue);
    console.log(this.invoice);
    if (this.revenue.invalid || this.invoice.invalid || this.formReceita.errors?.['invalidPayment']) {
      this.revenue.markAllAsTouched();
      this.invoice.markAllAsTouched();
      this.invoice.markAsDirty();
      this.markAllDisty(this.revenue.controls);
      this.markAllDisty(this.payer.controls);
      this.markAllDisty(this.address.controls);
      this.payments.controls.forEach((control: any) => {
        this.markAllDisty(control.controls);
      })
      return;
    }



    let clientId = localStorage.getItem("clientId");
    let unitId = localStorage.getItem("unitId");

    this.revenue.get("unit")?.setValue(`/api/units/${unitId}`);
    this.revenue.get("client")?.setValue(`/api/clients/${clientId}`);

    let form = this.formReceita.value;

    if (form.revenue.comissionProfessional > form.revenue.value) {
      this.notifyService.emitError("O valor da comissão do profissional não pode ser maior que o valor da venda.");
      return;
    }

    form.revenue.estimatedProfessionalAmount = this.isEditingCommission ? form.revenue.comissionProfessional : null;

    form.revenue.date = this.convertToDateString(form.revenue.date);

    delete form.revenue["itemCategory"];

    if (this.requiresAddressCompletion) {
      if (this.address.invalid) {
        this.address.markAllAsTouched();
        return;
      }

      form.revenue['address'] = this.convertEmptyStringsToNull(this.address.value);
      form.revenue['address'].number = form.revenue['address'].number?.toString();
      form.revenue['requiresAddress'] = this.requiresAddress;
    } else {
      const address = this.convertEmptyStringsToNull(this.address.value);
      const hasAddressData = [
        'postalCode',
        'streetAddress',
        'number',
        'district',
        'ibge',
        'state',
        'city',
        'address2',
        'email'
      ].some((field) => address[field] !== null && address[field] !== '');

      if (hasAddressData) {
        if (this.address.invalid) {
          this.address.markAllAsTouched();
          return;
        }

        form.revenue['address'] = address;
        form.revenue['address'].number = form.revenue['address'].number?.toString();
        form.revenue['requiresAddress'] = false;
      } else {
        delete form.address;
      }
    }
    this.loading = true;

    iif(() => form.id == null,
      this.revenueInvoiceEventService.post(form),
      this.revenueInvoiceEventService.edit(form, form.id))
      .pipe(
        catchError(error => {
          //this.notifyService.emitError(error.error['hydra:description']);
          return of(error.error['hydra:description']);
        })
      ).subscribe(
        (res) => {
          if (typeof res === 'string') {
            this.notifyService.emitError(res);
            this.loading = false;
            return;
          }
          this.notifyService.saveSuccess(`Receita #${res.id} Gerada Com Sucesso.`)
          this.dynamicDialogRef.close();
        }
      );
  }


  openModal(position: number) {
    let payment: Payment = this.payments.get(position.toString())?.value;
    console.log(payment);
    if (payment.paymentMethod != '/api/payment_methods/4') {
      if (payment.orderId == null) {
        this.positionPayment = position;
        this.selectedPayment = payment;
        this.splitSheetModalService.push("sheetModalMachine", { position: position });
        this.paymentMachineService.getAll().subscribe(
          (machines) => {
            console.log(machines);
            this.listMachine = machines;
          }
        )
      } else {
        this.positionPayment = position;
        this.selectedPayment = payment;
        if (payment.status == 'pending') {
          this.splitSheetModalService.push("sheetModalCancelPaymentMachine");
        } else {
          this.splitSheetModalService.push("sheetModalUnLinkMachine");
        }
      }
    } else {
      this.positionPayment = position;
      this.selectedPayment = payment;
      if (payment.orderId == null) {
        this.loadingSheetModalConfirmInvoices = true;
        this.splitSheetModalService.push("sheetModalConfirmInvoices");
        this.paymentMachineService.getCalculateFees(
          payment.paymentMethod,
          payment.value as number,
          payment.installmentCount as number)
          .subscribe(
            (response) => {
              this.paymentFees = response;
              this.loadingSheetModalConfirmInvoices = false;
            }
          );
      } else {
        this.splitSheetModalService.push("sheetModalPixPayment");
      }
    }
  }

  convertEmptyStringsToNull(obj: any) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === "") {
          obj[key] = null;
        }
      }
    }
    return obj;
  }

  convertToDateString(date: Date) {
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var dd = ("0" + (date.getDate())).slice(-2);
    var yy = date.getFullYear();
    var dateString = yy + '-' + mm + '-' + dd;
    return dateString;
  }

  closeModal() {
    this.splitSheetModalService.close("sheetModalMachine");
  }


  openModalClients() {
    this.splitSheetModalService.push("sheetModalClients");
  }

  closeModalClients() {
    this.splitSheetModalService.close("sheetModalClients");
  }

  closeModalUnLinkMachine() {
    this.splitSheetModalService.close("sheetModalUnLinkMachine");
  }


  confirmAddCustomer(id: number) {
    this.revenue.get('customer')?.setValue(id);
    this.closeModalClients();
  }

  convertPaymentMethod(payment: any) {
    let paymentMethod = this.listPaymentsMethod.find((paymentMethod: any) => paymentMethod['@id'] == payment);

    if (paymentMethod) {
      payment = paymentMethod.name;
    }

    return payment;
  }

  checkTypeInvoice(event: any) {
    let invoice = this.invoice.value;
    this.issueSettingsCachier = false;
    this.verifyItemCategory();
    if (invoice == '/api/revenue_invoice_settings/5') {
      this.issueSettingsCachier = true;
      this.revenue.get('category')?.setValue('/api/revenues/20');
    }
  }


  sendMachineOrder() {
    this.loadingInvoice = true;

    if (this.isReqFinished == false) {
      return;
    }
    this.isReqFinished = false

    let revenue = this.revenue.value;
    let payment = this.payments.get(this.positionPayment.toString())?.value;
    let description;

    if (revenue.itemCategory == "service") {
      description = this.listService.find((service: any) => service['@id'] == revenue.service)?.name;
    } else {
      description = this.listExams.find((exam: any) => exam['@id'] == revenue.exam)?.name;
    }

    let clientId = localStorage.getItem("clientId");
    let unitId = localStorage.getItem("unitId");

    let code = `${clientId}_${unitId}`;

    let amount = Math.round(payment.value * 100)

    if (payment.paymentMethod != '/api/payment_methods/4') {
      let order = {
        customer: {
          name: revenue.payer.firstName,
          document: revenue.payer.taxId,
          document_type: "CPF",
          type: "individual"
        },
        items: [
          {
            amount: amount,
            description: description,
            quantity: 1,
            code: code
          }
        ],
        closed: false,
        code: code,
        poi_payment_settings: {
          visible: true,
          print_order_receipt: false,
          devices_serial_number: [
            this.selectedMachine
          ],
          payment_setup: {
            type: this.paymentTypeMachine.find((paymentType: any) => paymentType.id == payment.paymentMethod)?.type,
            installments: payment.installmentCount != null ? payment.installmentCount : 1,
            installment_type: "merchant"
          },
          display_name: "Pedido #1"
        }
      }

      this.notifyService.emitWarn('Aguardando pagamento na maquininha ...', 'AtenÃ§Ã£o', true, true);

      this.machineOrderService.post(order).subscribe(
        {
          next: (result: any) => {
            this.loadingInvoice = false;
            this.isReqFinished = true
            this.payments.get(this.positionPayment.toString())?.get("orderId")?.setValue(result.partnerOrderId);
            this.payments.get(this.positionPayment.toString())?.get("status")?.setValue("pending");
            this.isWaitingPayment = true;
            this.isNextStepEnabled = false;


            let value = payment.value;
            this.serveSendEventService.createEventSourceOrderMachine(result.partnerOrderId).subscribe(
              (status: any) => {
                this.isWaitingPayment = false;
                this.isNextStepEnabled = true;
                this.notifyService.closeAll();
                if (status == "paid") {
                  this.notifyService.emitSuccess("Pagamento realizado com sucesso");
                } else if (status == "canceled") {
                  this.payments.get(this.positionPayment.toString())?.get("orderId")?.setValue(null);
                  this.notifyService.emitWarn("OperaÃ§Ã£o cancelada");
                }

                this.payments.get(this.positionPayment.toString())?.get("status")?.setValue(status);
                this.payments.markAsDirty();
                this.payments.updateValueAndValidity();
              }
            );

            this.closeModal();
          },
          error: (error: any) => {
            this.loadingInvoice = false;
            this.isReqFinished = true
          }
        }
      );
    } else {
      let order: any = {
        order: {
          customer: {
            name: revenue.payer.firstName,
            document: revenue.payer.taxId,
            document_type: "CPF",
            type: "individual"
          },
          items: [
            {
              amount: amount,
              description: description,
              quantity: 1,
              code: code
            }
          ],
          code: code,
          closed: false
        }
      }


      if (revenue.itemCategory == "service") {
        order.revenueInvoiceSetting = this.formReceita.get("invoice")?.value;
        order.service = revenue.service;
      }

      iif(
        () => revenue.itemCategory == "service",
        this.machineOrderService.postPixService(order),
        this.machineOrderService.postPixExam(order)
      ).subscribe(
        {
          next: (result: any) => {
            this.qrCodeUrl = result.pix.charges[0].last_transaction.qr_code_url
            this.payments.get(this.positionPayment.toString())?.get("orderId")?.setValue(result.pix.id);
            this.payments.get(this.positionPayment.toString())?.get("qrCodePix")?.setValue(result.pix.charges[0].last_transaction.qr_code);
            this.payments.get(this.positionPayment.toString())?.get("qrCodeUrlPix")?.setValue(result.pix.charges[0].last_transaction.qr_code_url);
            this.payments.get(this.positionPayment.toString())?.get("expiresPix")?.setValue(result.pix.charges[0].last_transaction.expires_at);
            this.payments.get(this.positionPayment.toString())?.get("status")?.setValue("pending");
            this.loadingInvoice = false;
            this.isReqFinished = true
            this.splitSheetModalService.push("sheetModalPixPayment");

            this.isWaitingPayment = true;
            this.selectedPayment = this.payments.get(this.positionPayment.toString())?.value;
            this.serveSendEventService.createEventSourceOrderMachine(result.pix.id).subscribe(
              (status: any) => {
                this.isWaitingPayment = false;
                this.notifyService.closeAll();
                if (status == "paid" || status == "splitted") {
                  this.notifyService.emitSuccess("Pagamento realizado com sucesso");
                  this.splitSheetModalService.close("sheetModalPixPayment");
                } else if (status == "canceled") {
                  this.payments.get(this.positionPayment.toString())?.get("orderId")?.setValue(null);
                  this.notifyService.emitWarn("OperaÃ§Ã£o cancelada");
                  this.splitSheetModalService.close("sheetModalPixPayment");
                }

                //status = status == "pending" ? "waiting" : status;
                this.payments.get(this.positionPayment.toString())?.get("status")?.setValue(status);
                this.payments.markAsDirty();
                this.payments.updateValueAndValidity();
              });
          },
          error: (error: any) => {
            this.loadingInvoice = false;
            this.isReqFinished = true
          }
        }
      );
    }
  }

  copyLinkPixPayment(link: any) {
    navigator.clipboard.writeText(link)
  }

  sendWhatsappMessage() {
    if (this.phoneWhatsApp.invalid) {
      this.phoneWhatsApp.markAllAsTouched();
      this.phoneWhatsApp.markAsDirty();
      return;
    }

    let message = `
      Segue o link de pagamento abaixo via pix no valor de ${new CurrencyPipe("pt-BR").transform(this.selectedPayment.value, 'BRL')}

      ${this.selectedPayment.qrCodePix}
    `;

    window.open(`https://wa.me/${this.phoneWhatsApp.value}?text=${window.encodeURIComponent(message)}`);
  }

  linkUnit() {
    let unitId = localStorage.getItem("unitId");
    this.dynamicDialogRef.close();
    this.router.navigate(['/cadastros/unidades'], { queryParams: { unit: unitId } });
  }



  canceledOrder() {
    let payment = this.payments.get(this.positionPayment.toString())?.value;
    if (payment.orderId != null) {
      this.loadingCancel = true;
      this.machineOrderService.cancelOrder(payment.orderId).subscribe(
        {
          next: () => {
            this.payments.removeAt(this.positionPayment);
            if (this.payments.length == 0) {
              let payment = Object.assign(this.clearPayment);
              payment.value = this.revenue.get("value")?.value;
              this.addPayment(payment);
            }
            this.verifyPayment();
            this.loadingCancel = false;
            this.isNextStepEnabled = true;
            this.closeModalUnLinkMachine();
            this.closeModalCancelPaymentMachine();
            this.closeModalPixPayment();
            this.isWaitingPayment = false;
            this.notifyService.closeAll();
          },
          error: () => {
            this.payments.removeAt(this.positionPayment);
            if (this.payments.length == 0) {
              let payment = Object.assign(this.clearPayment);
              payment.value = this.revenue.get("value")?.value;
              this.addPayment(payment);
            }
            this.verifyPayment();
            this.loadingCancel = false;
            this.closeModalUnLinkMachine();
            this.closeModalCancelPaymentMachine();
            this.closeModalPixPayment();
          }
        })
    }
  }

  unlinkOrder() {
    let payment = this.payments.get(this.positionPayment.toString())?.value;
    if (payment.orderId != null) {
      this.loadingCancel = true;
      this.isNextStepEnabled = true;
      this.machineOrderService.update(payment.orderId, {
        revenueEventId: "",
        revenuePaymentEventId: payment.id
      }).subscribe(
        () => {
          this.payments.removeAt(this.positionPayment);
          if (this.payments.length == 0) {
            let payment = Object.assign(this.clearPayment);
            payment.value = this.revenue.get("value")?.value;
            this.addPayment(payment);
          }
          this.verifyPayment();
          this.loadingCancel = false;
          this.closeModalUnLinkMachine();
        }
      )
    }
  }

  closeModalCancelPaymentMachine() {
    this.splitSheetModalService.close("sheetModalCancelPaymentMachine");
  }

  closeModalPixPayment() {
    this.splitSheetModalService.close("sheetModalPixPayment");
  }


  checkAndChangeViewToExams(item: any) {
    let label = (<HTMLElement>item.originalEvent.srcElement).getAttribute('aria-label');
    if (label?.toLowerCase().includes('exam')) {
      this.formReceita?.get('revenue.itemCategory')?.setValue('exam');
    }
  }

  cancelDialogInvoiceBlocked() {
    this.formReceita?.get('revenue.invoiceBlocked')?.setValue(false);
  }

  markAllDisty(controls: { [key: string]: AbstractControl<any, any>; }) {
    Object.keys(controls).forEach((key: any) => {
      (controls[key] as any).markAsDirty();
    });
  }

  toggleEditCommission() {
    this.isEditingCommission = true;
  }

  resetCommission() {
    this.isEditingCommission = false;
    this.updateCommission();
    this.validateCommission();
  }

  updateCommission() {
    if (this.isEditingCommission) return;

    let value = this.revenue.get("value")?.value;
    let services = this.revenue.get("service")?.value;
    let ser = this.listService.find((service: any) => service['@id'] == services);
    if (ser) {
      let professionalCommision = ser.flagPercentageTransferValue == true ? value * (ser.transferPercentage / 100) : ser.transferValue;
      this.revenue.get("comissionProfessional")?.setValue(professionalCommision);
    }
  }

  validateCommission() {
    const revenueValue = this.revenue.get('value')?.value ?? 0;
    const commissionValue = this.revenue.get('comissionProfessional')?.value ?? 0;

    if (commissionValue > revenueValue) {
      this.isNextStepEnabled = false;
      this.revenue.get('comissionProfessional')?.setErrors({ 'invalidCommission': true });
      this.revenue.get('value')?.setErrors({ 'invalidRevenue': true });
    } else {
      this.isNextStepEnabled = true;

      const commissionErrors = this.revenue.get('comissionProfessional')?.errors;
      if (commissionErrors) {
        delete commissionErrors['invalidCommission'];
        if (Object.keys(commissionErrors).length === 0) {
          this.revenue.get('comissionProfessional')?.setErrors(null);
        } else {
          this.revenue.get('comissionProfessional')?.setErrors(commissionErrors);
        }
      }

      const revenueErrors = this.revenue.get('value')?.errors;
      if (revenueErrors) {
        delete revenueErrors['invalidRevenue'];
        if (Object.keys(revenueErrors).length === 0) {
          this.revenue.get('value')?.setErrors(null);
        } else {
          this.revenue.get('value')?.setErrors(revenueErrors);
        }
      }
    }
  }

  generateNewIuiuid(){
    this.iuiuid = crypto.randomUUID();
  }
}
